import { Controller } from 'stimulus';
import Utility from '../classes/Utility';

class TickerMobileNavController extends Controller {
  static targets = [ 
    'navContainer',
    'navButton'
  ];

  connect() {
  }

  updateNav(e) {
    this.navButtonTarget.click();
    this.activeNav(e.target)
  }

  onScroll() {
    if(['m', 't'].includes(Utility.getDeviceType())) {
      this.navContainerTargets.forEach((el) => {
        if(this.isInViewport(el)){
          this.navButtonTarget.querySelector('#mobile-nav-title').textContent = el.dataset.sectionTitle;
          this.activeNav(document.getElementById(el.dataset.navId).querySelector('a'));
        }
      })
    }
  }

  activeNav(element) {
    document.querySelectorAll("[data-action='click->ticker-mobile-nav#updateNav']").forEach((el) => {
      el.querySelector('a').classList.remove('t-bg-mitre-purple-200');
    });
    element.classList.add('t-bg-mitre-purple-200');
  }

  isInViewport(container) {
    const { top, bottom } = container.getBoundingClientRect();
    const height = (window.innerHeight || document.documentElement.clientHeight);
  
    return ((top > 0 || bottom > 0) && (top + (height - 150)) < height);
  }
}

export default TickerMobileNavController;
